module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAc0lEQVQokWNgwAT/odgBTbwBKr4fXQMTFkNIBqOG0NGQB1DaAU1cH00eL5jPAEkP7xkYGBKghjUwINJPADGGCEAN+I8Fz8emgRGPQQkMDAz+UP4HBgaGjQwMDAuIcQVZAN0lDiTovcAAcSEDCwWGPIAZAgCg3Bpkg7VlTgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/03c.png
// module id = km52
// module chunks = 65